import { Radio, RadioGroup } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { BP_NS } from "@/css/constants";
import { LedgerAccountType } from "@/graphql";
import { formatCredits } from "@/utils/string";

interface LedgerAccountSelectorProps {
  ledgerAccounts: LedgerAccountType[];
  ledgerAccountId?: string;
  onSelectAccountId: (accountId: string) => void;
}

export function LedgerAccountSelector({
  ledgerAccounts,
  ledgerAccountId,
  onSelectAccountId,
}: LedgerAccountSelectorProps) {
  return (
    <StyledRadioGroup
      onChange={(e) => onSelectAccountId(e.currentTarget.value)}
      selectedValue={ledgerAccountId}
    >
      {ledgerAccounts &&
        ledgerAccounts.map((ledgerAccount) => (
          <Radio
            label={`${ledgerAccount.label} (${formatCredits(
              ledgerAccount.balance || "0.00",
            )})`}
            value={ledgerAccount.id}
            key={ledgerAccount.id}
          />
        ))}
    </StyledRadioGroup>
  );
}

const StyledRadioGroup = styled(RadioGroup)`
  .${BP_NS}-control {
    margin-bottom: 16px;
  }
`;
